import {
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from 'axios';

type CreateInterceptorProps<T> = {
  client: AxiosInstance;
  onFulfilled: (response: T) => T;
  onRejected?: (error: any) => any;
};

export function createResponseInterceptor<T = AxiosResponse<any>>({
  client,
  onFulfilled,
  onRejected,
}: CreateInterceptorProps<AxiosResponse<T>>) {
  client.interceptors.response.use(onFulfilled, onRejected);
}

export function createRequestInterceptor({
  client,
  onFulfilled,
  onRejected,
}: CreateInterceptorProps<InternalAxiosRequestConfig>) {
  client.interceptors.request.use(onFulfilled, onRejected);
}
